import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function PauseIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 256 256" {...props}>
      <Box as="rect" width="256" height="256" fill="none" />
      <Box
        as="circle"
        cx="128"
        cy="128"
        r="96"
        fill="none"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeWidth="16"
      />
      <Box
        as="line"
        x1="104"
        y1="96"
        x2="104"
        y2="160"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
      />
      <Box
        as="line"
        x1="152"
        y1="96"
        x2="152"
        y2="160"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
      />
    </Icon>
  );
}
